// Prevent closing from click inside dropdown
$(document).on('click', '.dropdown-menu', function (e) {
	e.stopPropagation();
});

function extraUrlCondition() {

	const disableLink = $('#primary-menu .menu-item a[href*="#"]');
	const disabledForClick = disableLink.closest('li');

	disabledForClick.addClass("disabled");

	$('.menu-item-has-children > a').on('click', function (event) {
		if ($(this).attr('href') !== '#') {
			event.preventDefault();
			window.location.href = $(this).attr('href');
		} else {
			event.preventDefault();
		}
	});

	$('.menu-item-has-children').each(function () {
		$(this).append('<span class="el-for-click"></span>');
	});
	const elForClick = $('.el-for-click');

	$(elForClick).on('click', function (event) {
		event.preventDefault();

		$(this).parent().toggleClass('active');
		$(this).toggleClass('active');
		$(this).siblings('.dropdown-menu').toggleClass('show');
	});

}

extraUrlCondition();

$('.navbar-toggler').click(function () {
	let previousScrollY = 0;

	if (!$('#primaryNavBar').hasClass('show')) {
		$('.navbar-toggler').addClass('close-menu');
		previousScrollY = window.scrollY;
		$('html').css({
			marginTop: -previousScrollY,
			overflow: 'hidden',
			left: 0,
			right: 0,
			top: 0,
			bottom: 0,
		});
		window.scrollTo(0, previousScrollY);
	} else {
		$('.navbar-toggler').removeClass('close-menu');
		$('html').css({
			marginTop: 0,
			overflow: 'visible',
			left: 'auto',
			right: 'auto',
			top: 'auto',
			bottom: 'auto',
			position: 'static',
		});
		window.scrollTo(0, previousScrollY);
	}
});

function ctaMenu() {
	let cta = document.querySelectorAll('.nav-primary__cta_item');
	if(cta.length > 0) {
		for(let i = 0; i < cta.length; i++) {
		cta[i].addEventListener('click', function() {
			$( ".navbar__close" ).trigger( "click" );
		})
		}
	}
}
ctaMenu()

$(window).resize(function () {
	const win = $(this);
	if (win.width() >= 992) {
		$('#primaryNavBar').removeClass('show');
		$('.navbar-nav').find('.menu-item.show').removeClass('show');
		$('.dropdown-menu').removeClass('show').removeAttr('style');
		$('.el-for-click').removeClass('active');
		$('.navbar-toggler').removeClass('close-menu');
		$('html').css({
			marginTop: 0,
			overflow: 'visible',
			left: 'auto',
			right: 'auto',
			top: 'auto',
			bottom: 'auto',
			position: 'static',
		});
	}
});

$(document).click(function (event) {
	let click = $(event.target);
	let _open = $(".navbar-collapse").hasClass("show"),
		block = $(".navbar-collapse.show");
	if (!block.is(event.target)
		&& block.has(event.target).length === 0) {
		if (_open === true && !click.hasClass("navbar-toggler")) {
			$(".navbar-toggler").click();
		}
	}
});





// WEBPACK FOOTER //
// ./scripts/modules/_navbar.js